<template>
    <div id="frame-general" class="container-frame">
        <h1 id="frame-title">{{ message }}</h1>
        <div id="container-general">
            <div class="general-sous-menu">
                <h2>Informations du praticien</h2>
                <div class="general-group">
                    <label>Prénom</label>
                    <input type="text" v-model="contrat.prenom" placeholder="Jean" class="input-field" disabled />
                </div>
                <div class="general-group">
                    <label>Nom</label>
                    <input type="text" v-model="contrat.nom" placeholder="Dupont" class="input-field" disabled />
                </div>
                <div class="general-group">
                    <label>Adresse 1</label>
                    <input type="text" v-model="contrat.adresse1" placeholder="123 rue des 3 cailloux" class="input-field" />
                </div>
                <div class="general-group">
                    <label>Adresse 2</label>
                    <input type="text" v-model="contrat.adresse2" placeholder="Appartement 4B, Immeuble A" class="input-field" />
                </div>
                <div class="general-group">
                    <label>Numéro de téléphone</label>
                    <input type="text" v-model="contrat.tel" placeholder="01 23 45 67 89" class="input-field" />
                </div>
                <div class="general-group">
                    <label>Adresse mail</label>
                    <input type="text" v-model="contrat.email" placeholder="jean.dupont@example.com" class="input-field" />
                </div>
                <div class="general-group">
                    <label>Contrat tarifaire</label>
                    <input type="text" placeholder="Contrat de base - Tarif Standard" class="input-field" />
                </div>
            </div>
            <div class="general-sous-menu">
                <h2>Envoi des rapports de réclamations</h2>
                <div class="general-group">
                    <label>Cliquez ici pour choisir une région : </label>
                    <img v-if="iconeRegions.path" class="iconeRegion" @click="afficherCarteRegions" :src="iconeRegions.path" :alt="iconeRegions.fullName" />
                </div>
                <transition name="fade">
                    <div v-if="carteVisible" class="modal-in-menu">
                        <div class="carte-container">
                            <canvas ref="canvasCarte" @click="selectionnerRegion" @mousemove="detecterRegion" class="carte-regions"></canvas>
                            <!-- Canvas superposé pour l'effet de surélévation -->
                            <canvas ref="canvasOverlay" class="carte-overlay"></canvas>
                            <button class="close-btn" @click="afficherCarteRegions">Fermer</button>
                        </div>
                    </div>
                </transition>
                <div class="general-group">
                    <p>{{selectedRegion}}</p>
                </div>
                <div class="general-group" id="messages">
                    <p v-if="errorMessageCarte" class="error-message-carte">{{ errorMessageCarte }}</p> <!-- Message d'erreur -->
                    <p v-if="successMessageCarte" class="success-message-carte">{{ successMessageCarte }}</p> <!-- Message de succès -->
                </div>
                <div class="general-group">
                    <div v-if="maRegion.path && maRegion.fullName">
                        <label>Ma région : <span class="labelMaRegion">{{ maRegion.fullName }}</span></label>
                        <img class="maRegion" :src="maRegion.path" :alt="maRegion.fullName">
                    </div>
                    <p v-else>Vous n'avez pas choisit votre région</p>
                </div>
            </div>
            <div class="general-sous-menu">
                <h2>Options de facturation</h2>
                <div class="general-group" v-for="option in facturationOptions" :key="option.value">
                    <input type="radio" name="facturation" v-model="contrat.facturation" :value="option.value" />
                    <label>{{ option.label }}</label>
                </div>
            </div>
            <div class="general-sous-menu">
                <h2>Tarifs Outre-Mer</h2>
                <div class="general-group">
                    <label for="tarifs-outremer">Sélectionner un département d'Outre-Mer : </label>
                    <select id="tarifs-outremer" class="input-field">
                        <option value="guyane-reunion"> Guyane - Réunion</option>
                        <option value="mayotte"> Mayotte</option>
                        <option value="antilles"> Antilles</option>
                    </select>
                </div>
            </div>
            <div class="general-sous-menu">
                <h2>Signature</h2>
                <div class="general-group" id="signature">
                    <canvas ref="canvasSignature" class="signature-canvas"></canvas>
                    <canvas ref="canvasCursor" class="cursor-canvas"></canvas>
                    <div class="btn-group" id="signer-btn">
                        <button @click="clearSignature">Effacer</button>
                        <button @click="saveSignature">Enregistrer</button>
                    </div>
                </div>
                <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p> <!-- Message d'erreur -->
                <p v-if="successMessage" class="success-message">{{ successMessage }}</p> <!-- Message de succès -->
            </div>
        </div>
        <div id="frame-footer">
            <button @click="annuler()">Annuler</button>
            <button @click="appliquer()">Appliquer</button>
        </div>
    </div>
</template>


<style scoped>
    @import "./parametre.css";
</style>


<script>
    import { ref, onMounted, defineComponent, nextTick, watch} from "vue";
    import SignaturePad from "signature_pad";
    import Values from "../../../script/Values";
    import RequestManager from "../../../script/request";
    import Client from "../../../script/Client";
    import Signature from "../../../script/Signature";
    import Region from "../../../script/Region";
    import { mapGetters } from 'vuex';

    export default defineComponent({
        data() {
            return {
                message: "Option Praticien",
                ctxCarte: null,
                ctxCursor: null,
                ctxSignature: null,
                lastPoint: null,
                lastTime: 0,
                speed: 1,
                isDrawing: false,
                canvasWidth: 0,
                canvasHeight: 0,
                previousWidth: 0,
                previousHeight: 0,
                originalWidthCarte: 500,
                originalHeightCarte: 462,
                claims: { email: "" },
                carteVisible: false,
                iconeRegions: { nameFile: "carte_regions_btn", path: "", fullName: "Bouton régions" },
                carteRegions: { nameFile: "carte_regions_plein", path: "", fullName: "Carte des régions"},
                maRegion: { fullName: "", path: "" },
                selectedRegion: null,
                hoverRegion: null,
                regions: [
                    { nameFile: "hauts_de_france", path: "", fullName: "Hauts-de-France", plageCoordonnees: [], plageCoordonneesRecalculees: [], color: [230, 184, 220] }, 
                    { nameFile: "normandie", path: "", fullName: "Normandie", plageCoordonnees: [], plageCoordonneesRecalculees: [], color: [215, 210, 166] },
                    { nameFile: "reunion", path: "", fullName: "La Réunion", plageCoordonnees: [], plageCoordonneesRecalculees: [], color: [127, 237, 169] },
                    { nameFile: "provence", path: "", fullName: "Provence-Alpes-Côte d'Azur", plageCoordonnees: [], plageCoordonneesRecalculees: [], color: [170, 215, 153] },
                    { nameFile: "occitanie", path: "", fullName: "Occitanie", plageCoordonnees: [], plageCoordonneesRecalculees: [], color: [98, 202, 203] },
                    { nameFile: "mayotte", path: "", fullName: "Mayotte", plageCoordonnees: [], plageCoordonneesRecalculees: [], color: [228, 178, 113] },
                    { nameFile: "martinique", path: "", fullName: "Martinique", plageCoordonnees: [], plageCoordonneesRecalculees: [], color: [250, 96, 0] },
                    { nameFile: "loire", path: "", fullName: "Pays de la Loire", plageCoordonnees: [], plageCoordonneesRecalculees: [], color: [246, 166, 166] },
                    { nameFile: "ile_de_france", path: "", fullName: "Ile-de-France", plageCoordonnees: [], plageCoordonneesRecalculees: [], color: [125, 167, 217] },
                    { nameFile: "guyane", path: "", fullName: "Guyane", plageCoordonnees: [], plageCoordonneesRecalculees: [], color: [181, 157, 208] },
                    { nameFile: "guadeloupe", path: "", fullName: "Guadeloupe", plageCoordonnees: [], plageCoordonneesRecalculees: [], color: [0, 169, 169] },
                    { nameFile: "corse", path: "", fullName: "Corse", plageCoordonnees: [], plageCoordonneesRecalculees: [], color: [243, 209, 140] },
                    { nameFile: "centre", path: "", fullName: "Centre-Val de Loire", plageCoordonnees: [], plageCoordonneesRecalculees: [], color: [232, 213, 152] },
                    { nameFile: "bretagne", path: "", fullName: "Bretagne", plageCoordonnees: [], plageCoordonneesRecalculees: [], color: [158, 193, 218] },
                    { nameFile: "bourgogne", path: "", fullName: "Bourgogne-Franche-Comté", plageCoordonnees: [], plageCoordonneesRecalculees: [], color: [186, 221, 200] },
                    { nameFile: "auvergne", path: "", fullName: "Auvergne-Rhône-Alpes", plageCoordonnees: [], plageCoordonneesRecalculees: [], color: [241, 157, 141] },
                    { nameFile: "aquitaine", path: "", fullName: "Nouvelle-Aquitaine", plageCoordonnees: [], plageCoordonneesRecalculees: [], color: [163, 214, 157] },
                    { nameFile: "grand_est", path: "", fullName: "Grand Est", plageCoordonnees: [], plageCoordonneesRecalculees: [], color: [166, 191, 224] }
                ],
                contrat: {
                    ADELI: "",
                    nom: "",
                    prenom: "",
                    adresse1: "",
                    adresse2: "",
                    tel: "",
                    email: ""
                },
                facturationOptions: [
                    { value: "securisee", label: "Sécurisée" },
                    { value: "degradee", label: "Dégradée" },
                    { value: "tla", label: "Pour la TLA" },
                    { value: "sans-vitale", label: "Sans Vitale" }
                ],
                errorMessage: "",
                successMessage: "",
                errorMessageCarte: "",
                successMessageCarte: "",
                timeout: null,
                isLoading: false
            };
        },
        watch: {
            "contrat.adresse1": "triggerUpdate",
            "contrat.adresse2": "triggerUpdate",
            "contrat.tel": "triggerUpdate",
            "contrat.email": "triggerUpdate"
        },
        computed: {
            GetSignaturePoints() {
                return this.$store.getters['ParametreOptionPraticien/GetSignaturePoints'];
            },
            ErrorGetSignaturePoints() {
                console.log("log erreur du store signature", this.$store.getters['ParametreOptionPraticien/ErrorGetSignaturePoints'])
                return this.$store.getters['ParametreOptionPraticien/ErrorGetSignaturePoints'];
            }
        },
        methods: {
            loadCarte() {
                const canvas = this.$refs.canvasCarte;
                if (!canvas) {
                    console.error("Canvas non trouvé !");
                    return;
                }
                this.ctxCarte = canvas.getContext("2d");
                const img = new Image();
                img.src = this.carteRegions.path;
                img.onload = () => {
                    canvas.width = img.width;
                    canvas.height = img.height;
                    this.ctxCarte.drawImage(img, 0, 0);

                    //console.log("Dimensions réelles du canvasCarte :", canvas.offsetWidth, canvas.offsetHeight);

                    this.setupOverlayCanvas();
                };
            },
            setupOverlayCanvas() {
                const canvasCarte = this.$refs.canvasCarte;
                const canvasOverlay = this.$refs.canvasOverlay;
                if (!canvasCarte || !canvasOverlay) return;

                canvasOverlay.width = canvasCarte.width;
                canvasOverlay.height = canvasCarte.height;
            },
            drawHoverRegion(region) {
                const canvasOverlay = this.$refs.canvasOverlay;
                const ctx = canvasOverlay.getContext("2d");
                if (!ctx || !region.path) return;

                this.clearOverlayCanvas();

                const img = new Image();
                img.src = region.path;

                img.onload = () => {
                    ctx.drawImage(img, 0, 0, canvasOverlay.width, canvasOverlay.height);
                };
            },
            clearOverlayCanvas() {
                const canvasOverlay = this.$refs.canvasOverlay;
                const ctx = canvasOverlay.getContext("2d");
                if (!ctx) return;
                ctx.clearRect(0, 0, canvasOverlay.width, canvasOverlay.height);
            },
            detecterRegion(event) {
                const canvas = this.$refs.canvasCarte;
                if (!canvas) return;

                const rect = canvas.getBoundingClientRect();

                const x = (event.clientX - rect.left);
                const y = (event.clientY - rect.top);

                const epsilon = 0.5;
                
                const regionTrouvee = this.regions.find(region =>
                    region.plageCoordonneesRecalculees.some(coord =>
                        Math.abs(coord.x - x) < epsilon && Math.abs(coord.y - y) < epsilon
                    )
                );

                if (regionTrouvee) {
                    if (regionTrouvee == this.hoverRegion) {
                        return;
                    } else {
                        this.selectedRegion = regionTrouvee.fullName;
                        this.hoverRegion = regionTrouvee;
                        this.drawHoverRegion(regionTrouvee);
                    }  
                } else {
                    this.hoverRegion = null;
                    this.clearOverlayCanvas();
                    this.selectedRegion = null;
                }
            },
            selectionnerRegion(event) {
                if (this.selectedRegion) {
                    //console.log("Région sélectionnée :", this.selectedRegion);
                    const regionTrouvee = this.regions.find(region =>
                        region.fullName.trim() === this.selectedRegion.trim()
                    );

                    if (regionTrouvee) {
                        this.saveRegion(regionTrouvee.nameFile);
                    }
                }
            },
            afficherCarteRegions() {
                this.successMessageCarte = "";
                this.errorMessageCarte = "";
                this.carteVisible = !this.carteVisible;
                if (this.carteVisible) {
                    this.$nextTick(() => {
                        this.loadCarte();
                    });
                }
            },
            async loadIconeRegions() {
                try {
                    const response = await Region.getOneRegion(this.iconeRegions.nameFile);
                    if (response) {
                        const base64Image = response;

                        if (base64Image) {
                            this.iconeRegions.path = `data:image/png;base64,${base64Image}`;
                        } else {
                            console.warn(`Image Base64 vide pour ${this.iconeRegions.nameFile}`);
                        }
                    } else {
                        console.warn(`Donnée invalide pour ${this.iconeRegions.nameFile}`, response);
                    }
                } catch (error) {
                    console.error(`Erreur lors du chargement de l'image de ${this.iconeRegions.nameFile}:`, error);
                }
            },
            async loadCarteRegions() {
                try {
                    const response = await Region.getOneRegion(this.carteRegions.nameFile);
                    if (response) {
                        const base64Image = response;

                        if (base64Image) {
                            this.carteRegions.path = `data:image/png;base64,${base64Image}`;
                        } else {
                            console.warn(`Image Base64 vide pour ${this.carteRegions.nameFile}`);
                        }
                    } else {
                        console.warn(`Donnée invalide pour ${this.carteRegions.nameFile}`, response);
                    }
                } catch (error) {
                    console.error(`Erreur lors du chargement de l'image de ${this.carteRegions.nameFile}:`, error);
                }
            },
            async loadRegions() {
                for (let region of this.regions) {
                    try {
                        const response = await Region.getOneRegion(region.nameFile);
                        if (response) {
                            const base64Image = response;

                            if (base64Image) {
                                region.path = `data:image/png;base64,${base64Image}`;
                            } else {
                                console.warn(`Image Base64 vide pour ${region.nameFile}`);
                            }
                        } else {
                            console.warn(`Donnée invalide pour ${region.nameFile}`, response);
                        }
                    } catch (error) {
                        console.error(`Erreur lors du chargement de l'image de ${region.nameFile}:`, error);
                    }
                }
                //console.log("Régions mises à jour :", this.regions);
            },
            async saveRegion(regionName) {
                for (let region of this.regions) {
                    if (region.nameFile == regionName) {
                        try {
                            //console.log("region namefile :", region.nameFile, "region Name : ", regionName);
                            const response = await Region.saveRegion(region.nameFile);
                            if (response) {
                                //console.log(`Enregistrement de la région choisie ${region.nameFile}`, response);
                                this.successMessageCarte = "Enregistrement de votre région réussi !";
                                this.errorMessageCarte = "";
                                this.loadMaRegion();
                            } else {
                                this.successMessageCarte = "";
                                this.errorMessageCarte = "L'enregistrement de votre région a échoué.";
                            }
                        } catch (error) {
                            console.error(`Erreur lors de l'enregistrement de la région ${region.nameFile}`, error);
                        }
                        return null;
                    }
                }
            },
            async extractRegionCoordinates() {
                for (let region of this.regions) {
                    if (!region.path) continue;

                    const img = new Image();
                    img.src = region.path;

                    await new Promise((resolve) => {
                        img.onload = () => {
                            const canvas = document.createElement("canvas");
                            const ctx = canvas.getContext("2d");

                            canvas.width = img.width;
                            canvas.height = img.height;
                            ctx.drawImage(img, 0, 0);
                            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                            const data = imageData.data;

                            let pixelsRegion = [];

                            for (let y = 0; y < canvas.height; y++) {
                                for (let x = 0; x < canvas.width; x++) {
                                    const index = (y * canvas.width + x) * 4;
                                    const r = data[index];
                                    const g = data[index + 1];
                                    const b = data[index + 2];
                                    const alpha = data[index + 3];

                                    if (r > 200 && g > 200 && b > 200 && alpha > 0) {
                                        pixelsRegion.push({ x, y });
                                    }
                                }
                            }

                            region.plageCoordonnees = pixelsRegion;
                            //console.log(`Coordonnées précises pour ${region.fullName}:`, region.plageCoordonnees.length, "pixels");

                            resolve();
                        };
                    });
                }
            },
            async recalculateRegionCoordinates() {
                await this.$nextTick();

                const canvas = this.$refs.canvasCarte;
                if (!canvas || !this.originalWidthCarte || !this.originalHeightCarte) return;

                const rect = canvas.getBoundingClientRect();

               //console.log("Dimensions affichées :", rect.width, rect.height);
                //console.log("Dimensions internes :", canvas.width, canvas.height);

                const scaleX = rect.width / this.originalWidthCarte;
                const scaleY = rect.height / this.originalHeightCarte;
                //console.log("vérification des dimensions de bases : ", this.originalWidthCarte, this.originalHeightCarte);

                for (let region of this.regions) {
                    region.plageCoordonneesRecalculees = region.plageCoordonnees.map(coord => ({
                        x: coord.x * scaleX,
                        y: coord.y * scaleY,
                    }));
                }

                //console.log("Coordonnées recalculées !");
                //console.log("Taille affichée:", rect.width, rect.height);
                //console.log("Facteurs d'échelle:", scaleX, scaleY);
            },
            async loadMaRegion() {
                try {
                    const response = await Region.getMyRegion();
                    if (response) {
                        for (let region of this.regions) {
                            if (region.nameFile == response.name) {
                                //console.log("Enregistrement de la région dans maRegion : ", response.name);
                                this.maRegion.fullName = region.fullName;

                                const img = new Image();
                                img.src = `data:image/png;base64,${response.image}`;
                                img.onload = () => {
                                    const canvas = document.createElement("canvas");
                                    const ctx = canvas.getContext("2d");

                                    canvas.width = img.width;
                                    canvas.height = img.height;
                                    ctx.drawImage(img, 0, 0);

                                    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                                    const data = imageData.data;

                                    let minX = canvas.width, minY = canvas.height, maxX = 0, maxY = 0;

                                    for (let i = 0; i < data.length; i += 4) {
                                        const r = data[i], g = data[i + 1], b = data[i + 2], alpha = data[i + 3];

                                        if (r > 200 && g > 200 && b > 200 && alpha > 0) {
                                            data[i] = region.color[0];
                                            data[i + 1] = region.color[1];
                                            data[i + 2] = region.color[2];

                                            const x = (i / 4) % canvas.width;
                                            const y = Math.floor(i / 4 / canvas.width);

                                            if (x < minX) minX = x;
                                            if (x > maxX) maxX = x;
                                            if (y < minY) minY = y;
                                            if (y > maxY) maxY = y;
                                        }
                                    }

                                    ctx.putImageData(imageData, 0, 0);

                                    const croppedWidth = maxX - minX + 1;
                                    const croppedHeight = maxY - minY + 1;
                                    const croppedCanvas = document.createElement("canvas");
                                    const croppedCtx = croppedCanvas.getContext("2d");

                                    croppedCanvas.width = croppedWidth;
                                    croppedCanvas.height = croppedHeight;
                                    croppedCtx.drawImage(canvas, minX, minY, croppedWidth, croppedHeight, 0, 0, croppedWidth, croppedHeight);

                                    this.maRegion.path = croppedCanvas.toDataURL("image/png");
                                    //console.log("Image ma region : ", this.maRegion.path);
                                };

                                return;
                            }
                        }
                    }
                } catch (error) {
                    console.error("Erreur lors du chargement de ma région", error);
                }
            },
            observeCanvasSize() {
                const canvas = this.$refs.canvasCarte;
                if (!canvas) return;

                this.resizeObserver = new ResizeObserver(() => {
                    clearTimeout(this.resizeTimeout);
                    this.resizeTimeout = setTimeout(() => {
                        this.recalculateRegionCoordinates();
                    }, 200);
                });

                this.resizeObserver.observe(canvas);
            },
            cleanupObserver() {
                if (this.resizeObserver) {
                    this.resizeObserver.disconnect();
                    this.resizeObserver = null;
                }
            },
            triggerUpdate() {
                if (this.isLoading) return;
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.sauvegarderModifications();
                }, 1000);
            },
            async sendDimensionsToBackend() {
                if (this.canvasWidth !== this.previousWidth || this.canvasHeight !== this.previousHeight) {
                    const canvas = this.$refs.canvasSignature;
                    if (!canvas) return;

                    RequestManager.EnvoyerMessageWebView({
                        action: "UpdatePadDimensions",
                        parameters: [canvas.width.toString(), canvas.height.toString()],
                    });

                    this.previousWidth = this.canvasWidth;
                    this.previousHeight = this.canvasHeight;
                }
            },
            async fetchClaims() {
                const token = RequestManager.getToken();
                if (!token) {
                    console.warn("TOKEN == null");
                    return;
                }
                this.claims = await Values.GetClaims(token);
                if (this.claims?.email) {
                    await this.fetchContrat();
                } else {
                    console.error("Impossible de récupérer l'email de l'utilisateur.");
                }
            },
            async fetchContrat() {
                if (!this.claims?.email) {
                    alert("L'email de l'utilisateur est introuvable !");
                    return;
                }
                try {
                    this.isLoading = true;
                    this.contrat = await Client.getClientWithEmail(this.claims.email);
                    if (this.contrat.ADELI) {
                        console.log(this.contrat.ADELI);
                        await this.loadSignature();
                    }
                    await this.$nextTick();
                    this.isLoading = false;
                } catch (error) {
                    this.isLoading = false;
                    console.error("Erreur lors de la récupération du contrat :", error);
                }
            },
            async sauvegarderModifications() {
                if (!this.contrat?.email) {
                    alert("Il faut rentrer une adresse mail pour valider les modifications");
                    return;
                }
                try {
                    let clientActuel = await Client.getClientWithEmail(this.claims.email);
                    //console.log("CLIENT ACTUEL : ", clientActuel);
                    const data = {
                        ...clientActuel,
                        email: this.contrat.email,
                        adresse1: this.contrat.adresse1,
                        adresse2: this.contrat.adresse2,
                        tel: this.contrat.tel
                    };
                    await Client.postUpdateInfosClient(data);
                    let token = await Values.GenerateTokenClient(data);
                    //console.log("TOKEN : ", token);
                    let setToken = await RequestManager.setToken(token);
                    //console.log("SET TOKEN  : ", setToken);
                    let response = await this.fetchClaims();
                    //console.log("REPONSE APRES MODIFS", response);
                    console.log("Modifications enregistrées !");
                } catch (error) {
                    console.error("Erreur lors des modifications : ", error);
                }
            },
            startDrawing(event) {
                if (event.button !== 0) return;
                event.preventDefault();
                // Garder le pointeur capture : le trace continue meme si le
                // doigt deborde legerement du canvas.
                if (event.pointerId !== undefined && event.target.setPointerCapture) {
                    event.target.setPointerCapture(event.pointerId);
                }
                this.isDrawing = true;
                this.lastPoint = this.getCanvasPosition(event);
                this.lastTime = Date.now();
            },
            draw(event) {
                if (!this.isDrawing) return;

                const currentPoint = this.getCanvasPosition(event);
                const currentTime = Date.now();
                const timeDifference = currentTime - this.lastTime;

                const distance = Math.sqrt(
                    Math.pow(currentPoint.x - this.lastPoint.x, 2) + Math.pow(currentPoint.y - this.lastPoint.y, 2)
                );

                const speed = distance / timeDifference;

                const lineWidth = Math.min(Math.max(speed * 3, 1), 3);

                this.ctxSignature.lineWidth = lineWidth;

                this.ctxSignature.beginPath();
                this.ctxSignature.moveTo(this.lastPoint.x, this.lastPoint.y);
                this.ctxSignature.lineTo(currentPoint.x, currentPoint.y);
                this.ctxSignature.stroke();

                this.lastPoint = currentPoint;
                this.lastTime = currentTime;
            },
            stopDrawing() {
                this.isDrawing = false;
            },
            getCanvasPosition(event) {
                const canvas = this.$refs.canvasSignature;
                const rect = canvas.getBoundingClientRect();
                const scaleX = canvas.width / rect.width;
                const scaleY = canvas.height / rect.height;

                return {
                    x: (event.clientX - rect.left) * scaleX,
                    y: (event.clientY - rect.top) * scaleY
                };
            },
            async loadSignature() {
                if (!this.contrat.ADELI) return;
                try {
                    const base64Image = await Signature.getSignature(this.contrat.ADELI);
                    if (base64Image) {
                        const img = new Image();
                        img.src = `data:image/png;base64,${base64Image}`;
                        img.onload = () => {
                            const canvas = this.$refs.canvasSignature;
                            this.ctxSignature = canvas.getContext("2d");
                            this.ctxSignature.clearRect(0, 0, canvas.width, canvas.height);
                            this.ctxSignature.drawImage(img, 0, 0, canvas.width, canvas.height);
                        };
                        this.successMessage = "Signature trouvée !"
                    }
                } catch (error) {
                    this.errorMessage = "Aucune signature trouvée.";
                }
            },
            isCanvasEmpty(ctx) {
                const canvas = ctx.canvas;
                const pixelData = ctx.getImageData(0, 0, canvas.width, canvas.height).data;

                for (let i = 0; i < pixelData.length; i += 4) {
                    if (pixelData[i + 3] !== 0) {
                        return false;
                    }
                }
                return true;
            },
            clearSignature() {
                if (this.ctxSignature) {
                    this.ctxSignature.clearRect(0, 0, this.ctxSignature.canvas.width, this.ctxSignature.canvas.height);
                }
                this.lastPoint = null;
                this.errorMessage = "";
                this.successMessage = "";
            },
            async saveSignature() {
                if (!this.ctxSignature) {
                    this.errorMessage = "Canvas non initialisé.";
                    this.successMessage = "";
                    return;
                }
                const isEmpty = this.isCanvasEmpty(this.ctxSignature);
                if (isEmpty) {
                    this.errorMessage = "Veuillez signer avant d'enregistrer";
                    this.successMessage = "";
                    return;
                }

                const signatureData = this.ctxSignature.canvas.toDataURL("image/png").split(",")[1];

                try {
                    await Signature.saveSignature(this.contrat.ADELI, signatureData);
                    this.successMessage = "Signature enregistrée avec succès !";
                    this.errorMessage = "";
                } catch {
                    this.errorMessage = "Erreur lors de l'enregistrement de la signature";
                    this.successMessage = "";
                }
            },
            updateCanvasSize(canvasSignature, canvasCursor) {
                const width = canvasSignature.offsetWidth;
                const height = canvasSignature.offsetHeight;

                // Mettre à jour la taille du canvas en pixels
                canvasSignature.width = width;
                canvasSignature.height = height;
                canvasCursor.width = width;
                canvasCursor.height = height;

                this.canvasWidth = width;
                this.canvasHeight = height;

                console.log("Canvas redimensionné :", width, height);
            },
            drawStylet() {
                if (!this.ctxSignature || !this.ctxCursor || this.GetSignaturePoints.length === 0) return;

                const lastPoint = JSON.parse(this.GetSignaturePoints[this.GetSignaturePoints.length - 1]);

                this.ctxCursor.clearRect(0, 0, this.ctxCursor.canvas.width, this.ctxCursor.canvas.height);

                // Gestion de la pression du stylet sur le pad
                const pressure = Math.min(Math.max(lastPoint.Pressure, 100), 10000); // Limitation de la pression entre 100 et 10 000
                const lineWidth = Math.min(Math.max(pressure / 500, 1), 5);

                if (lastPoint.ButtonPressed === true) {
                    this.ctxSignature.save();
                    this.ctxSignature.globalCompositeOperation = "destination-out";
                    this.ctxSignature.beginPath();
                    this.ctxSignature.arc(lastPoint.X, lastPoint.Y, 6, 0, Math.PI * 2);
                    this.ctxSignature.fill();
                    this.ctxSignature.restore();

                    this.ctxCursor.beginPath();
                    this.ctxCursor.arc(lastPoint.X, lastPoint.Y, 3, 0, Math.PI * 2);
                    this.ctxCursor.fillStyle = "black";
                    this.ctxCursor.fill();

                } else if (this.lastPoint && lastPoint.ButtonPressed === false) {
                    this.ctxSignature.beginPath();
                    this.ctxSignature.moveTo(this.lastPoint.X, this.lastPoint.Y);
                    this.ctxSignature.lineTo(lastPoint.X, lastPoint.Y);
                    this.ctxSignature.strokeStyle = "black";
                    this.ctxSignature.lineWidth = lineWidth;
                    this.ctxSignature.stroke();
                }

                this.lastPoint = lastPoint;
            }
        },
        async mounted() {
            await this.loadCarteRegions();
            await this.loadRegions();
            await this.loadIconeRegions();
            await this.loadMaRegion();
            await this.extractRegionCoordinates();
            await this.fetchClaims();
            nextTick(() => {
                const canvasSignature = this.$refs.canvasSignature;
                const canvasCursor = this.$refs.canvasCursor;

                if (canvasSignature && canvasCursor) {
                    this.updateCanvasSize(canvasSignature, canvasCursor);

                    this.signatureResizeObserver = new ResizeObserver(() => {
                        this.canvasWidth = canvasSignature.offsetWidth;
                        this.canvasHeight = canvasSignature.offsetHeight;

                        this.sendDimensionsToBackend();
                    });

                    // Observer les deux canvas
                    this.signatureResizeObserver.observe(canvasSignature);

                    this.ctxSignature = canvasSignature.getContext("2d");
                    this.ctxCursor = canvasCursor.getContext("2d");

                    this.ctxSignature.lineCap = "round";

                    // Pointer events : unifient souris, tactile (doigt) et stylet.
                    // Les mouse* seuls ne fonctionnent pas au doigt sur mobile
                    // (pas de mousemove synthetise pendant le glissement).
                    canvasSignature.addEventListener("pointerdown", this.startDrawing);
                    canvasSignature.addEventListener("pointermove", this.draw);
                    canvasSignature.addEventListener("pointerup", this.stopDrawing);
                    canvasSignature.addEventListener("pointercancel", this.stopDrawing);
                    canvasSignature.addEventListener("pointerleave", this.stopDrawing);
                }
            });

            watch(() => this.GetSignaturePoints, this.drawStylet, { deep: true });
            watch(() => this.carteVisible, (newVal) => {
                if (newVal) {
                    nextTick(() => {
                        this.observeCanvasSize();
                    });
                } else {
                    this.cleanupObserver();
                }
            });
        }
    });

</script>
